import { COMPGROUPS_HAS_ERROR, COMPGROUPS_IS_LOADING, COMPGROUPS_FETCH_DATA_SUCCESS, COMPGROUPS_CREATE_CACHE} from '../actions/compgroups'

   
export function compgroupsHasError(state = null, action) {
    switch (action.type) {
        case COMPGROUPS_HAS_ERROR:
            return action.error;

        default:
            return state;
    }
}

export function compgroupsIsLoading(state = false, action) {
    switch (action.type) {
        case COMPGROUPS_IS_LOADING:
            return action.isLoading;

        default:
            return state;
    }
}

export function compgroups(state = [], action) {
    switch (action.type) {
        case COMPGROUPS_FETCH_DATA_SUCCESS:
            return action.groups;
   
        default:
            return state;
    }
}

export function compgroupsCache(state = [], action) {
    switch (action.type) {
        case COMPGROUPS_CREATE_CACHE:
            return action.groupsCache;
          
        default:
            return state;
    }
}